"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intlI18n = require("@/i18n/intl-i18n");
var _IntlBreadcrumb = _interopRequireDefault(require("../components/IntlBreadcrumb.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// ============================================================
// 国际交流展示页逻辑
// ============================================================
var _default = exports.default = {
  name: 'IntlAbout',
  mixins: [_intlI18n.intlMixin],
  components: {
    IntlBreadcrumb: _IntlBreadcrumb.default
  }
};